export const EMAIL = "pymevisible@gmail.com";

export const INSTAGRAM = "https://www.instagram.com/pymevisible/";
export const FACEBOOK = "https://web.facebook.com/profile.php?id=61593198355425&locale=es_LA";
export const WHATSAPP_NUMERO = "56922065450";
export const TELEFONO_E164 = "+56922065450";
export const TELEFONO_VISIBLE = "+56 9 2206 5450";
export const WHATSAPP_BASE = `https://wa.me/${WHATSAPP_NUMERO}`;
export const WHATSAPP = `${WHATSAPP_BASE}?text=Hola%2C%20quiero%20saber%20m%C3%A1s%20sobre%20los%20productos%20NFC%20%2B%20QR%20de%20Pyme%20Visible`;

export const WHATSAPP_DIAGNOSTICO = `${WHATSAPP_BASE}?text=Hola,%20quiero%20revisar%20la%20presencia%20de%20mi%20negocio%20en%20Google`;

export const CTA_PRINCIPAL = "Ver productos NFC";
export const CTA_MICROCOPY = "Configurados y listos para usar";

export function gmailComposeUrl(params?: { subject?: string; body?: string }) {
  const url = new URL("https://mail.google.com/mail/");
  url.searchParams.set("view", "cm");
  url.searchParams.set("fs", "1");
  url.searchParams.set("to", EMAIL);
  if (params?.subject) url.searchParams.set("su", params.subject);
  if (params?.body) url.searchParams.set("body", params.body);
  return url.toString();
}

export const OPCIONES_INTERES = [
  "Stand Google NFC + QR — $20.000",
  "Stand Instagram NFC + QR — $20.000",
  "Stand WhatsApp NFC + QR — $20.000",
  "Llavero NFC + QR — $10.000",
  "Llavero NFC — $10.000",
  "Tarjeta Google NFC — $10.000",
  "Stand personalizado NFC + QR — $30.000",
  "Adhesivo personalizado NFC + QR — $20.000",
  "Perfil de Empresa en Google",
  "Sitio web personalizado",
  "Fotografía profesional",
  "No estoy seguro / quiero asesoría",
] as const;

export type Interes = (typeof OPCIONES_INTERES)[number];

export const INTERES_EVENT = "pymevisible:interes";

export function preseleccionarInteres(interes: Interes) {
  window.dispatchEvent(new CustomEvent<Interes>(INTERES_EVENT, { detail: interes }));
}
